// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getTransfersColumns = () => ({
    listColumns: [
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'status',
            key: translate('STATUS')
        },
        {
            id: 'currentDealerLocation',
            key: translate('CURRENT_DEALER_LOCATION')
        },
        {
            id: 'newDealerLocation',
            key: translate('NEW_DEALER_LOCATION')
        },
        {
            id: 'customer',
            key: translate('CUSTOMER')
        },
        {
            id: 'requestedBy',
            key: translate('REQUESTED_BY')
        },
        {
            id: 'requestedDate',
            key: translate('REQUESTED')
        }
    ],
    listId: 'transfers'
});



// WEBPACK FOOTER //
// ./src/product/transfers/services/excel-columns.js